import styled from 'styled-components';

export const ComparisonView = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ComparisonBody = styled.div`
  flex: 1;
  padding: 25px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
`;
